export const TIP_ID = {
  PROMO: 'promotion',
  ADD_PAYMENT: 'add_payment',
  CREATE_CAMPAIGN: 'create_campaign',
  COACHING: 'coaching',
  HELP: 'help',
};
